// admin/src/Component/SpotAnalyzer/List.js
import React from 'react';
import {
    List,
    Datagrid,
    TextField,
    DateField,
    EditButton,
    Pagination,
    TextInput,
    Filter,
    Button,
    CreateButton,
    ExportButton,
    ReferenceField,
    usePermissions,
    BooleanField,
    BulkDeleteButton
} from 'react-admin';
import RefreshSpotAnalyzer from './RefreshSpotAnalyzer';
import DownloadXlsx from './DownloadXlsx';
import CloneSpotAnalyzer from "./CloneSpotAnalyzer";
import authProvider from "../../authProvider";
import UploadSpots from "./UploadSpots";
import CreateDashboard from "./CreateDashboard";
import DashboardLinkField from "./DashboardLinkField";
import SyncIcon from '@material-ui/icons/Sync';
import CardActions from "@material-ui/core/CardActions";
import config from 'react-global-configuration';

const SpotAnalyzerFilter = (props) => (
    <Filter {...props} autoComplete="off">
        <TextInput label="Search name" source="name" alwaysOn options={{
            autoComplete: 'off',
            inputProps: { 'data-lpignore': 'true' },
        }} />
    </Filter>
);

const SyncButton = ({ page }) => {

    const webUrl = config.get('app.web_url');

    if(typeof(page) !== 'undefined') {

        return (
            <Button
                href={`${webUrl}/sync-mapi/`}
                target="_blank"
                rel="noopener noreferrer"
                label="Sync MAPI"
            >
                <SyncIcon/>
            </Button>
        );
    }

    return null;
}

const cardActionStyle = {
    zIndex: 2,
    display: 'inline-block',
    float: 'right',
};

const SpotAnalyzerShowActions = ({ basePath, data }) => (
    <CardActions style={cardActionStyle}>
        <CreateButton basePath={basePath} />
        <ExportButton basePath={basePath} />
        <SyncButton page={data} />
    </CardActions>
);


const PostPagination = props => <Pagination rowsPerPageOptions={[10, 25, 50, 100, 500]} {...props} />;

const campaignRowStyle = (record, index) => {

    if(record) {

        if (record.ready === false && record.added_to_dashboard === false) {
            return {
                backgroundColor: '#ffebee'
            }
        } else if (record.ready === true && record.added_to_dashboard === false && record.spot_analyzer_type === '/api/spot-analyzer-types/spot-evaluator') {
            return {
                backgroundColor: '#ffd78c'
            }
        }
    }

    return null;
};

export const SpotAnalyzerList = (props) => {

    const {permissions} = usePermissions();

    const bulkActionButtons = authProvider.isAuthorised(permissions, ['ROLE_ADMIN'])
        ? <BulkDeleteButton mutationMode="pessimistic" />
        : false;

    return (
        <List filters={<SpotAnalyzerFilter/>} {...props} title="RTV" perPage={100} pagination={<PostPagination/>}
              sort={{field: 'updateDate', order: 'DESC'}} actions={<SpotAnalyzerShowActions />} bulkActionButtons={bulkActionButtons}>
            <Datagrid rowStyle={campaignRowStyle}>

                <BooleanField source="ready" label="Ready" />
                <BooleanField source="added_to_dashboard" label="Dashboard" />

                <DashboardLinkField source="name" label="Name"/>
                <DateField source="update_date" sortBy="updateDate" showTime locales="nl-NL"/>
                <TextField source="created_by" />

                <ReferenceField label="Type" source="spot_analyzer_type" reference="spot-analyzer-types">
                    <TextField source="name"/>
                </ReferenceField>

                <EditButton/>

                {authProvider.isAuthorised(permissions, ['ROLE_ADMIN']) &&  <CloneSpotAnalyzer/>}
                {authProvider.isAuthorised(permissions, ['ROLE_ADMIN']) &&  <RefreshSpotAnalyzer/>}
                {authProvider.isAuthorised(permissions, ['ROLE_ADMIN']) &&  <UploadSpots/>}
                <DownloadXlsx/>

                {authProvider.isAuthorised(permissions, ['ROLE_ADMIN']) &&   <CreateDashboard/>}

            </Datagrid>
        </List>);
};